
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { voltageData } from '@/data/energy-analytics-data';
import ChartLegend from '@/components/charts/ChartLegend';

const AlarmTelemetryChart = () => {
  return (
    <AnimatedCard 
      animation="fade-up"
      delay={100}
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Alarm Telemetry (V)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={voltageData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="time" />
              <YAxis domain={[210, 240]} />
              <Tooltip 
                formatter={(value) => [`${value}V`, 'Voltage']}
                contentStyle={{ 
                  borderRadius: '8px', 
                  border: 'none', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
                }}
              />
              <Line 
                type="monotone" 
                dataKey="voltage" 
                stroke="#FF453A" 
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
          
          {/* Add Chart Legend below the chart */}
          <ChartLegend 
            payload={[
              { dataKey: 'voltage', value: 'Voltage (V)', color: '#FF453A' }
            ]}
          />
        </div>
      </CardContent>
    </AnimatedCard>
  );
};

export default AlarmTelemetryChart;
